import React from 'react'
import { useState, useEffect } from 'react'
import "./CardPreview.css";
import dictionary from '../../../constants/cardsDictionary.json'

function CardPreview({ card, houseCard }) {

  const filteredCards = new Set([
    'plus_1', 'plus_2', 'plus_3', 'plus_4', 'plus_5', 'plus_6',
    'neg_1', 'neg_2', 'neg_3', 'neg_4', 'neg_5', 'neg_6',
    'plus_neg_1', 'plus_neg_2', 'plus_neg_3', 'plus_neg_4', 'plus_neg_5', 'plus_neg_6'
  ]);

  const isHouseCard = filteredCards.has(card);

  return (
    <div className="whole-container card-preview-container">
      <h1 className="container-title" style={{ color: '#FFFFFF' }}>
        {card === "" &&
          dictionary.housePowerCards["plus_1"].name
        }
        {isHouseCard && card !== "" &&
          dictionary.housePowerCards[card].name
        }
        {!isHouseCard && card !== "" &&
          dictionary.nftPowerCards[card].name
        }
      </h1>
      <h1
        className="container-subtitle"
        style={{ color: isHouseCard || card === "" ? "#229563" : "#00D1FF" }}
      >
        {card === "" ? "House Power Card" : isHouseCard ? "House Power Card" : "Zoombies NFT Card"}

      </h1>
      {
        card === "" &&
        <img
          src={`/bonez/images/cards/power-cards/plus_1.svg`}
          className="card-preview"
          alt="House power card" />
      }
      {
        isHouseCard && card !== "" &&
        <img
          src={`/bonez/images/cards/power-cards/${card.toString()}.svg`}
          className="card-preview"
          alt="House power card" />
      }
      {
        !isHouseCard && card !== "" &&
        <img src={`/bonez/images/cards/power-cards/${card.toString()}.svg`} className="card-preview" alt="House power card" />
      }


      <h1
        className="container-body-text card-description"
        style={{ color: "#FFFFFF", marginBottom: "0" }}
      >
        {card === "" &&
          dictionary.housePowerCards["plus_1"].description
        }
        {isHouseCard && card !== "" &&
          dictionary.housePowerCards[card].description
        }
        {!isHouseCard && card !== "" &&
          dictionary.nftPowerCards[card].description
        }
      </h1>
    </div>
  )
}

export default CardPreview